import service from "@irati/utils/tracking/index"

import {
  StepParams,
  StepAndOptionsParams,
  ClickModalParams,
  ExitSetupParams,
  ViewResetChangesModalParams,
  ResetModalParams,
  ReminderParams
} from "./interfaces"

const TRACKING_ROOT = "admin_onboarding_"

class TenantSetupTracking {
  viewStep = (params: StepParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}view_step`, params)
  }

  navigateStep = (params: StepParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}navigate_step`, params)
  }

  selectOption = (params: StepAndOptionsParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}select_option`, params)
  }

  markStepComplete = (params: StepAndOptionsParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}mark_step_complete`, params)
  }

  markStepSkipped = (params: StepAndOptionsParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}mark_step_skipped`, params)
  }

  finishSetup = (params: StepAndOptionsParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}finish_setup`, params)
  }

  viewSetupModal = () => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}view_setup_modal`)
  }

  clickSetupModal = (params: ClickModalParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}dismiss_setup_modal`, params)
  }

  exitSetup = (params: ExitSetupParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}dismiss_setup_modal`, params)
  }

  viewResetChangesModal = (params?: ViewResetChangesModalParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}view_warning_modal`, params)
  }

  resetChangesModalAction = (params: ResetModalParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}dismiss_warning_modal`, params)
  }

  openIntercom = (params: StepAndOptionsParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}open_intercom`, params)
  }

  viewTenantSetupReminderTile = (params: ReminderParams) => {
    service.trackOnboardingEvent(`${TRACKING_ROOT}view_reminder_tile`, params)
  }
}

const tenantSetupTracking = new TenantSetupTracking()

export {default as TenantSetupInterfaces} from "./interfaces"
export {ClickedModalValues, ExitSetupButtonValues, ResetModalClickedValues, ReminderPlatformValues} from "./enums"
export default tenantSetupTracking
